import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { Select, type SelectProps } from '@/components/controls';

export type FormSelectProps = Omit<
  SelectProps,
  'selectedOption' | 'setSelectedOption'
> & {
  control?: Control;
};

export const FormSelect = ({ name, control, ...props }: FormSelectProps) => {
  return (
    <Controller
      name={name as string}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <Select
            {...props}
            selectedOption={value}
            setSelectedOption={onChange}
          />
        );
      }}
    />
  );
};

FormSelect.displayName = 'Form.Select';

export const required = (
  message = 'The field is required',
  defaultValue = { id: '', value: null },
) => {
  return z
    .object({
      id: z.string().min(1, { message }),
      value: z.string().nullable(),
    })
    .catchall(z.any())
    .default(defaultValue)
    .refine((value) => value.id !== '', {
      message,
    });
};

FormSelect.rules = { required };
